module.exports = __webpack_public_path__ + "static/preview-4-d673c4777ffbceffb4e7a1da7b7aafe0.png";